// extracted by mini-css-extract-plugin
export default {"shadow":"scrollabe-shadow_shadow__Strv6","first":"scrollabe-shadow_first__miwXv","last":"scrollabe-shadow_last__TR5fd"};